import {
  NewButton,
  NewButtonSize,
  NewButtonVariant,
  TooltipTrigger,
} from "@visiblethread/react-components";
import { idPropType } from "constants/app";
import { modalTypes } from "constants/types";
import { Trash2Icon } from "lucide-react";
import { string } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import {
  setSelectedRowIds,
  updateOutlineSections,
} from "slices/proposalOutline/outlineSlice";
import {
  selectProposalOutlineSections,
  selectSelectedRowIds,
} from "slices/proposalOutline/selectors";
import { pluralize } from "utils/string";

import classes from "./DeleteButton.module.scss";

const DeleteButton = ({ sectionId, title }) => {
  const selectedRowIds = useSelector(selectSelectedRowIds);
  const sections = useSelector(selectProposalOutlineSections);

  // If sectionId is NOT part of selectedRowIds, we can infer
  // the user is hovering over a Row that wasn't selected with
  // checkboxes.
  const finalTargetIds = selectedRowIds.includes(sectionId)
    ? selectedRowIds
    : [sectionId];
  const hasMultipleSelected = finalTargetIds.length > 1;

  const dispatch = useDispatch();

  const onConfirmDelete = () => {
    let removed;
    if (hasMultipleSelected) {
      removed = sections.filter((s) => !finalTargetIds.includes(s.id));
      dispatch(setSelectedRowIds());
    } else {
      removed = sections.filter((s) => s.id !== sectionId);
    }

    dispatch(updateOutlineSections(removed));
  };

  const onClickDelete = (e) => {
    e.stopPropagation();
    const type = pluralize("section", finalTargetIds.length);
    const target = hasMultipleSelected ? "all selected sections" : title;

    dispatch(
      showModal(modalTypes.DELETE_OUTLINE_SECTIONS_MODAL, {
        finalTargetIds,
        onConfirmDelete,
        target,
        type,
      })
    );
  };
  return (
    <TooltipTrigger
      classes={classes.icon_button_tooltip}
      content={hasMultipleSelected ? "Delete Selected" : "Delete Row"}
    >
      <NewButton
        variant={NewButtonVariant.red}
        size={NewButtonSize.sm}
        leftIcon={<Trash2Icon size={16} />}
        classes={classes.icon_button}
        data-show-on-row-hover
        data-testid="delete-section-btn"
        onClick={onClickDelete}
      ></NewButton>
    </TooltipTrigger>
  );
};

DeleteButton.propTypes = {
  sectionId: idPropType,
  title: string,
};

export default DeleteButton;
